// 请求地址

const BASE = '',
  // EVBASE = process.env.API_EV,
  ECM_DOWNLOAD = `DownLoad`,
  ECM = `api/services/`,
  USER_URL = `/api/UserCenter/`, // 登录模块
  TREE_URL = `/api/ProTreeDiagram/`, // 获取目录树
  FactData_URL = `/api/FactData/`, // 文件管理
  HysysManager_URL = `/api/Hysys/`,
  DRAW_URL = `/api/Drawing/`,
  MAP_URL = `/api/Polling/`,
  CHAT_URL = `/nodeConcat`,
  USER = {
    getuserlist: `${USER_URL}getuserlist`, // 获取体验账号集合
    loginOctopus: `${USER_URL}userLogin`, // octopus
    logOut: `${USER_URL}userLogOut`, // octopus退出登录
    getUserInfo: `${USER_URL}getUserInfoByToken`, // octopus获取用户信息
    systemManage: `${ECM}System/MemberFunctions`, // ecm
    getAllUser: '/api/UserCenter/getAllUserData',　// octopus获取所有用户
    CheckUserTokenValidity: `${ECM}Org/CheckUserTokenValidity`, // ecm
    changePwd: `${USER_URL}changeUserPassword`, // octopus
    faceTest: `${USER_URL}DetectFace`,
    verifyFace: `${USER_URL}VerifyFace`,
    getAuth: '/api/jurisdiction/GetUserPrivileges', // 查询权限列表
    getSysMessage: 'api/SystemBulletin/getNoticeByUserID', // 获得系统公告
    updateNotice: 'api/SystemBulletin/updateNotice',
    getAlertList: 'api/concernsMsg/getConcernsMsgById', // 获得警告列表
    updateConcernsMsg: 'api/concernsMsg/updateConcernsMsg',
  },
  TREE = {
    first: `${TREE_URL}getProTreeDiagramModel`, // 一级
    treeson: `${TREE_URL}getbindzstoggle`, // 二级
    guids: `${TREE_URL}getTreeChildGuids`,
    property: `/api/ProTreeDiagram/getPropertyInfo`,
    add: `${TREE_URL}adddevice`,
    update: `${TREE_URL}updatedevice`,
    devicelist: `${TREE_URL}getdeviceList`,
    deletedevice: `${TREE_URL}deletedevice`,
    addextraprop: `/api/ProTreeDiagram/addextraprop`,
    removeExtraProp: `/api/ProTreeDiagram/removeExtraProp`,
    getcctvdatalist: `${TREE_URL}getcctvdatalist`,
    getcctvTypeData: `${TREE_URL}getcctvTypeData`,
    getYsToken: 'api/user/getYsToken',
    addwarningsetting: `${TREE_URL}addwarningsetting`,
    gethistorydeviceData: `${TREE_URL}gethistorydeviceData`,
    getModelLocationData: `${TREE_URL}GetModelLocationData`,
    updateModelLocationData: `${TREE_URL}UpdateModelLocationData`,
    getOpticDeviceList: `${TREE_URL}GetOpticDeviceList`
  },
  DOC = {
    upload: `/api/Document/DocUpload`, // 上传
    getdocclass: `/api/Document/getdocclass`, // 获取文档类型
    doclistpage: `/api/Document/doclistpage`, // 文档列表
    docVisList: `/api/Document/docversionslist`, // 历史版本列表
    deleteDoc: `/api/Document/deletedoc`, // 删除文档数据
    delVisDoc: `/api/Document/deletedocVersions`, // 删除历史版本文档
    fileConcat: `/api/Document/AddDocRelevance`, // 关联文件
    fileCheck: `/api/Document/DocRelevanceList`, // 关联文件
    cancelConcat: `/api/Document/cancelAssociated`, // 取消关联
    // searchDocByBitNum: `/api/Document/SearchBitNumberDoc`, // 搜索文件
    searchDocByBitNum: `/api/Document/GetDocRelevanceData`, // 搜索文件
    fileUpdateCheck: `/api/Document/AddOrUpdateDocRelevance`, // 关联文件
    docPreview: `/api/Doc/SearchEnterPriseDocInfo`, // 预览
    fileSearch: `/api/Search/SearchDoc`, // 搜索
    attrSearch: `/api/Search/SearchAssociatedData`, // 搜索
    fileNameUpdate: `/api/Document/UpdataDoc`, // 文件更新
    fileDelete: `/api/Document/DeleteRelDoc`, // 文件更新
    bitList: `/api/Document/DataBerNumberDelationship`, // 位置列表
    dieList: `/api/DieModel/GetDieDataList`, // 模型数据列表
    delModel: `/api/DieModel/DeleteDieModel`, // 删除模型
    getModelData: '/api/ModelDataSPC/GetModelData', // 获得模型数据
    setAngel: '/api/ModelDataSPC/setAngelCodeByBitNumber', // 设置模型视角
    getBitById: '/api/PidSvg/GetBitGId',
    getDocCodeFareaData: `/api/DocumentCode/getDocCodeFareaData`,
    getDocCodeAreaData: `/api/DocumentCode/getDocCodeAreaData`,
    getDocCodeTechnologyData: `/api/DocumentCode/getDocCodeTechnologyData`,
    copyDocFilder: `/api/services/Doc/CopyFolderListAndFileList`, // ecm
  },
  FactData = {
    factDataPage: `${FactData_URL}factDataPage`, // 获取实时数据集合
    addentering: `${FactData_URL}addentering`, // 添加手动录入数据
    addfactdata: `${FactData_URL}addfactdata` // 添加自动监控实时数据监控
  },
  HysysManager = {
    AddHysysRequest: `${HysysManager_URL}AddHysysRequest`, // 获取实时数据集合
    AddHysysResponse: `${HysysManager_URL}AddHysysResponse`, // 添加手动录入数据
    GetHysysModelData: `${HysysManager_URL}GetHysysModelData`, // 添加自动监控实时数据监控
    getResultHysysResponse: `${HysysManager_URL}getResultHysysResponse` // 添加自动监控实时数据监控
  },
  // ECM接口
  octopus_doc = {
    getDocList: `/api/Doc/GetOctpusEnterPriseDataList`, // 获得文件列表
    deleteFile: `/api/Doc/DeleteEnterPriseData`, // 删除文件
    upload: '/api/Doc/enterpriseUploadFile',
    updateDoc: '/api/Doc/UpdateDocVersion',
    downLoad: '/api/Doc/enterpriseDownLoad',
    fileRename: `/api/Doc/UpdateDocEntDocName`, // 文件重命名
    getTagById: `${ECM}Doc/GetFileTagListByFileId`, // 通过文件ID获取标签列表
    setFileTags: `${ECM}Doc/SetFileTagList`, // 给文件设置多个标签
    setFileListTags: `${ECM}Doc/SetFileListWithTagList`, // 批量给文件设置标签
    getFolderChildren: `/api/Doc/GetEntFileDataList`,
    createFolder: `/api/Doc/AddNewFile`,
    searchDoc: '/api/Doc/SearchEnterPriseDoc',
    GetTopFolderId: `${ECM}Doc/GetTopFolderId`, // 获得文件列表
    getDocInfoByFid: '/api/Doc/SearchEnterPriseDocInfo'
  },
  personDrive = {
    getPersonDoc: '/api/File/getNewFile',
    addPersonDoc: '/api/File/addNewFile',
    addNewFolder: '/api/File/addNewFolder',
    reFileName: '/api/File/reFileName',
    fileDownload: '/api/File/fileDownload',
    delFile: '/api/File/delFileName'
  },
  DRAW = {
    GetThreeDrawingData: `${DRAW_URL}GetThreeDrawingData`, //
    GetTwoDrawingData: `${DRAW_URL}GetTwoDrawingData`, //
    GetCadDataList: '/api/Drawing/GetCadListPage', //
    getCadListByBit: '/api/Drawing/BitNumberToSvg'
  },
  MAP = {
    GetGpsData: `${MAP_URL}GetGpsData`,
    InspectData: `${MAP_URL}InspectData`,
    ScreenTodayIdseatData: `${MAP_URL}ScreenTodayIdseatData`,
    DelTodayIdseatData: `${MAP_URL}DelTodayIdseatData`,
    GetKeyMessageDataPage: `${MAP_URL}GetKeyMessageDataPage`,
    AddKeyMessage: `${MAP_URL}AddKeyMessage`,
    getPathList: `${MAP_URL}GetPathData`,
    updatePathData: `${MAP_URL}UpdatePathData`,
    deletePathData: `${MAP_URL}DeletePathData`,
    addPathData: `${MAP_URL}AddPathData`
  },
  CHAT = {
    uploadFile: `${CHAT_URL}/fileUpload`,
    loginChat: `${CHAT_URL}/login`,
    GetRoomId: `${CHAT_URL}/GetRoomId`,
    getMore: `${CHAT_URL}/getMore`,
    changeNewsStatus: `${CHAT_URL}/changeNewsStatus`,
    loginOut: `${CHAT_URL}/loginOut`,
    getRoomHistory: `${CHAT_URL}/getRoomHistory`,
    loginOut: `${CHAT_URL}/loginOut`,
    ECMDownloadFile: `${CHAT_URL}/ECMDownloadFile`,
    quitRoom: `${CHAT_URL}/quitRoom`,
    getUserHeadPic: `/api/user/GetUserHeadPic`,
    ECMCreateRoom: `${CHAT_URL}/ECMCreateRoom`,
  },
  ORG = {
    getDepartByIdentId: `/api/DeptRead/GetDepartmentInfoByIdentityId`,
    getChildDepartByIdentId: `/api/DeptRead/GetChildDepartmentListByIdentityId`,
    getPosByIdentId: `/api/PositionRead/GetPositionInfoByIdentityId`,
    getChildPosByIdentId: `/api/PositionRead/GetChildPositionListByIdentityId`,
    getGroupList: `/api/GroupRead/GetGroups`,
    getUserList: `/api/UserRead/SearchUserListPaged`,
    searchMember: `/Component`
  },
  AMIS = {
    getAmisDataPage: `/api/AMIS/getAmisDataPage`,
    getCorrosionTaskData: `/api/ReportManager/GetBiCorrosionData`,
    updateCorrosionTask: `/api/AMIS/UpdateCorrosionTask`,
    getPidSvgList: `/api/PidSvg/GetPidSvgList`,
    getAreaList: '/api/Collections/GetAreaDataList',
    getDeviceMaintainLog: '/api/AMIS/GetDeviceMaintainLog',
    excuteImage: '/api/AMIS/ExcuteImage',
    getCadMpy: '/api/AMIS/getCadMpy',
    getCorrosionMpy: '/api/AMIS/GetCorrosionMpy',
    getWallThickMpy: '/api/AMIS/GetWallThickMpy',
    exportWallThickR: '/api/AMIS/ExportWallThickR',
    excuteDWG: '/api/AMIS/ExcuteDWG',
    addPsData: '/api/AMIS/AddPsData',
    getPsData: '/api/AMIS/GetPsData',
    taskImport: '/api/AMIS/taskImport',
    getCorrosionMpyData: '/api/AMIS/GetCorrosionMpyData',
  },
  COLLECT = {
    getCollectList: `/api/Collections/GetUserAreaList`,
    getAllCollectList: `/api/Collections/GetAreaDataList`,
    getAllFileLIst: `/api/Collections/GetBitNumberJson`,
    addFile: `/api/Collections/AddCollections`,
    addArea: `/api/Collections/AddArea`,
    deleteArea: `/api/Collections/DeleteArea`,
    deleteCollect: `/api/Collections/DelCollections`,
    updateCollectFile: `/api/Collections/UpdateCollections`,
    getNumber: `/api/ModelDataSPC/getModelData`,

    getPersonList: `/api/Collections/GetExtraSettingData`,
    addPersonList: `/api/Collections/AddExtraSetting`,
    setPersonaList: `/api/Collections/UpdateExtraSetting`,
    addUserPrivileges: `api/jurisdiction/AddUserPrivileges`,
  },
  HEAD = {
    HeadUpload: `/ImageType/HeadUpload?r=${Math.random()}`,
    getEcmHead: `/api/services/Org/GetUserFace`,
    upSpcHead: `${USER_URL}userUpLoadHeadImage`, // octopus
    getSourceFace: `/ImageType/GetSourceFaceImage`,
    imgCut: `/ImageType/ImgCut`,
  },
  TABLES = {
    getDayReport: 'api/ReportManager/GetDailyReport',
    getLaboratoryData: 'api/ReportManager/GetLaboratoryData',
    setLaboratoryData: 'api/ReportManager/AddLaboratoryData',
    getProductOut: 'api/ReportManager/GetProductOut',
    setProductOut: 'api/ReportManager/AddProductOut',
    getComprehensiveDaily: 'api/ReportManager/GetComprehensiveDaily',
    GetCalTime: 'api/ReportManager/GetCalTime',
    setDailyReport: 'api/ReportManager/AddDailyReport',
    GetBaseData: 'api/ReportManager/GetBaseData',
    getBiData: 'api/ReportManager/GetBIReportData',
    getProductData: 'api/ReportManager/GetBIProductRunManage',
    getHSEManage: 'api/ReportManager/GetHSEManage',
    GetBigScreenWarnData: 'api/ReportManager/GetBigScreenWarnData',
    getBIBusiness: 'api/ReportManager/GetBIBusiness',
    getDcsFactDevice: 'api/ReportManager/GetDcsFactDevice',
    getDcsHistory: 'api/DCS/GetDcsHistoryData',
    getPollingTrackRouteLIst: 'api/DCS/GetPollingTrackRouteLIst',
    addPollingTrackRoute: 'api/DCS/AddPollingTrackRoute',
    getHseTVDataList: 'api/DCS/GetHseTVDataList',
    getRealDataLog: 'api/DCS/getRealDataLog',
    clearData: 'api/DCS/realDataClear'
  },
  HYS = {
    getHysTime: '/api/Hysys/GetHysysProSimulation',
    setHysTime: '/api/Hysys/AddOrUpdateHysysTime',
    getHysDataTable: '/api/Hysys/GetHysysDataPage',
    getBestResult: '/api/Hysys/GetOptimalDataList',
    GetHysysReportData: '/api/Hysys/GetHysysReportData',
    GetHysysOptimizeParam: '/api/Hysys/GetHysysOptimizeParam',
    StartHysysFigureup: '/api/Hysys/StartHysysFigureup',
    EndHysysFigureup: '/api/Hysys/EndHysysFigureup',
    GetHysysRroPriceData: '/api/Hysys/GetHysysRroPriceData',
    GetWarringData: '/api/Hysys/GetWarringData',
    GetEnergyData: '/api/Hysys/GetEnergyData',
    GetEnergyPriceDataList: '/api/Hysys/GetEnergyPriceDataList',
  },
  exportReport = {
    exportLaboratoryData: '/api/ReportManager/exportLaboratoryData',
    exportComprehensiveDaily: '/api/ReportManager/exportComprehensiveDaily',
    exportProductOut: '/api/ReportManager/exportProductOut',
    exportDailyReportt: '/api/ReportManager/exportDailyReportt',
    exportHysysReportData: '/api/Hysys/exportHysysReportData'
  },
  warn = {
    addWarn: `/api/warnMark/AddWarnMark`,
    searchWarn: `/api/warnMark/getWarnMarkList`
  },
  views = {
    addView: '/api/ViewManagement/AddViewManage',
    deleteView: '/api/ViewManagement/DeleteViewManage',
    editView: '/api/ViewManagement/UpdateViewManage',
    getViewList: '/api/ViewManagement/GetViewManageList',
    setDefault: '/api/ViewManagement/setDefaultViewManage',
    getRoam: '/api/PidSvg/getRoam',
    delRoam: '/api/PidSvg/delRoam',
    addRoam: '/api/PidSvg/addRoam',
    addRoamPath: '/api/PidSvg/addRoamRoute',
    getRoamPath: '/api/PidSvg/getRoamRoute',
    delRoamPath: '/api/PidSvg/delRoamRoute',
    getSvgPid: '/api/PidSvg/getSvgPidByBitNumber',
    getDcsData: '/api/PidSvg/getDcsDataSummary'
  },
  viewManagement = {
    getSignListL: `/api/ViewManagement/GetSignList`,
    deleteSign: `/api/ViewManagement/DeleteSign`,
    addSing: `/api/ViewManagement/AddSing`
  },
  DASH = {
    GetRealTimeDataList: '/api/Dashboard/GetRealTimeDataList',
    GetEtchPlanDataList: '/api/Dashboard/GetEtchPlanDataList',
    GetCorrosionMpyDatalist: '/api/Dashboard/GetCorrosionMpyDatalist',
    GetWallThicknessData: '/api/Dashboard/GetWallThicknessData',
  },
  BiView = {
    getBiData: `/api/ReportManager/BIRunStatusHealthData`
  }


// 导出模块
export default {
  BiView,
  USER,
  TREE,
  personDrive,
  DOC,
  FactData,
  HysysManager,
  octopus_doc,
  DRAW,
  MAP,
  CHAT,
  DASH,
  ORG,
  AMIS,
  COLLECT,
  HEAD,
  TABLES,
  exportReport,
  warn,
  HYS,
  viewManagement,
  views
}



// WEBPACK FOOTER //
// ./src/config/API-config.js